<template>
  <div class="newest">
    <div class="newestHead">
      <p>最新上架</p>
      <a href="javascript:;" @click="goBookList">更多</a>
    </div>
    <ul class="newestList">
      <li v-for="(item, index) in list" :key="index" @click="goBookInfo(item.bookId)">
        <div>
          <img :src="item.cover" alt>
          <div><div>推</div></div>
        </div>
        <div>
          <div>
            <p class="bookName">{{item.bookName}}</p>
            <p class="bookDescribe">{{ item.summary | valLength(44) }}</p>
          </div>
          <div>
            <p class="authorName">{{item.authorName | playNum}}</p>
            <p>{{item.readSum | playNum}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
//  v-html="$options.filters.valLen(item.summary, 44)"
export default {
  // name: "首页最新上架"
  data() {
    return {
      list: []
    };
  },
  created() {
    var that = this;
    var data = {
      page: {
        pageNum: 1,
        pageSize: 3
      },
      ticket: localStorage.getItem("ticket")
    }
    that.allApi.newArrival(data).then(function(resource) {
      // console.log(JSON.parse(resource.data))
      that.list = resource.data.data.list;
    });
  },
  methods: {
    goBookInfo(id) {
      var that = this;
      that.$emit("goBookInfo", id);
    },
    goBookList() {
      var that = this;
      var data = {
        type: "newest",
        name: "最新上架"
      }
      that.$router.push({
        path: "/classBookList",
        query: data
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.newest {
  width: rem(666px);
  margin: 0 auto rem(60px);
  > .newestHead {
    margin-bottom: rem(46px);
    overflow: hidden;
    > p {
      float: left;
      font-size: rem(36px);
      line-height: rem(50px);
      font-weight: bold;
      color: #111;
      position: relative;
      padding-left: rem(20px);
      &::before{
        content: "";
        position: absolute;
        left: 0;
        top: rem(13px);
        overflow: hidden;
        border-right: rem(5px) solid #349AF6;
        height: rem(24px);
      }
    }
    > a {
      float: right;
      font-size: rem(24px);
      color: #999;
      background: url("../../assets/imgs/index/more.png") center right /
        rem(18px) rem(29px) no-repeat;
      padding-right: rem(20px);
      line-height: rem(50px);
    }
  }
  > .newestList {
    > li {
      width: 100%;
      padding-bottom: rem(30px);
      margin-bottom: rem(30px);
      border-bottom: 1px solid #E5E5E5;
      overflow: hidden;
      display: flex;
      &:last-child {
        margin-bottom: 0;
        border-bottom: 0;
        padding-bottom: 0;
      }
      >div:first-child{
        width: rem(200px);
        height: rem(200px);
        position: relative;
        margin-right: rem(40px);
        border-radius: rem(6px);
        overflow: hidden;
        > img {
          display: block;
          width: rem(200px);
          height: rem(200px);
        }
        >div{
          position: absolute;
          right: 0;
          bottom: 0;
          width: rem(50px);
          height: rem(50px);
          background: url('../../assets/imgs/index/homeState.png') center / rem(50px) rem(50px) no-repeat;
          
          >div{
            width: rem(50px);
            height: rem(50px);
            text-align: right;
            display: table-cell;
            vertical-align: bottom;
            color: #fff;
            font-size: rem(20px);
          }
        }
      }
      
      > div:last-child {
        width: 0%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        >div:first-child{
          .bookName {
            font-size: rem(32px);
            font-weight: bold;
            color: #111;
            line-height: rem(45px);
            margin-bottom: rem(10px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bookDescribe {
            font-size: rem(24px);
            color: #999;
            line-height: rem(32px);
          }
        }
        
        >div:last-child{
          overflow: hidden;
          font-size: rem(24px);
          color: #333;
          line-height: rem(34px);
          >p{
            float: left;
            position: relative;
            padding-left: rem(30px); 
            &:first-child{
              margin-right: rem(42px);
              &::before{
                content: "";
                background: url('../../assets/imgs/index/anchorIcon.png') center / rem(25px) rem(25px) no-repeat;
                width: rem(25px);
                height: rem(25px);
                position: absolute;
                left: 0;
                top: rem(3px);
              }
            }
            &:last-child{
              &::before{
                content: "";
                background: url('../../assets/imgs/index/playNumIcon.png') center / rem(25px) rem(25px) no-repeat;
                width: rem(25px);
                height: rem(25px);
                position: absolute;
                left: 0;
                top: rem(3px);
              }
            }
          }
        }
      }
    }
  }
}
</style>
